<template>
  <div class="content">
    <el-form  :model="form" :disabled="true" label-width="150px">
      <el-card  shadow="never"  style="width: 70%;">
        <div slot="header" class="clearfix">
          <span style="font-size:20px;color:#181818;font-weight: 600;">主体信息</span>
        </div>
        <el-form-item label="企业名称：" prop="company"  v-if="form.kycType==2">
          <el-input v-model="form.company"  placeholder="企业名称"></el-input>
        </el-form-item>
        <el-form-item label="营业执照注册号：" prop="companyNumber"  v-if="form.kycType==2">
          <el-input v-model="form.companyNumber"  placeholder="营业执照注册号"></el-input>
        </el-form-item>
        <el-form-item label="身份证姓名：" prop="realName" >
          <el-input v-model="form.realName"  placeholder="身份证姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证身份证号：" prop="idCard" >
          <el-input v-model="form.idCard"  placeholder="身份证身份证号"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone" >
          <el-input v-model="form.phone"  placeholder="手机号码"></el-input>
          <div style="color:#999">此手机号为企业提现认证手机号，请确保填写的手机号码可直接联系到本人，否则认证失败。</div>
        </el-form-item>
      </el-card>
      <el-card  shadow="never"  style="width: 70%;">
        <div slot="header" class="clearfix">
          <span style="font-size:20px;color:#181818;font-weight: 600;">图片资料</span>
        </div>
        <el-row>
          <el-col :span="12">
              <el-form-item label="身份证正面：">
                <el-image  v-if="form.personHeadImg"
                  style="width: 100px; height: 100px"
                  :src="form.personHeadImg"
                  :preview-src-list="[form.personHeadImg]">
                </el-image>
                <svg-icon v-if="!form.personHeadImg" icon-class="idcard_front" class="svg-avatar-uploader-icon" />
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="身份证反面：">
                <el-image  v-if="form.personBackImg"
                  style="width: 100px; height: 100px"
                  :src="form.personBackImg"
                  :preview-src-list="[form.personBackImg]">
                </el-image>
                <svg-icon v-if="!form.personBackImg" icon-class="idcard_reverse" class="svg-avatar-uploader-icon" />
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
              <el-form-item label="营业执照正面："  v-if="form.kycType==2">
                <el-image  v-if="form.companyImg"
                  style="width: 100px; height: 100px"
                  :src="form.companyImg"
                  :preview-src-list="[form.companyImg]">
                </el-image>
                <svg-icon v-if="!form.companyImg" icon-class="business_license" class="svg-avatar-uploader-icon" />
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="手持身份证半身照：">
                <el-image  v-if="form.personPeopleImg"
                  style="width: 100px; height: 100px"
                  :src="form.personPeopleImg"
                  :preview-src-list="[form.personPeopleImg]">
                </el-image>
                <svg-icon v-if="!form.personPeopleImg" icon-class="idcard_hand" class="svg-avatar-uploader-icon" />
              </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
  </div>
</template>
<script>
import { userAuthenticationInfo } from "@/api/api.js";
export default {
  name: "authenticationInfo",
  data() {
    return {
      form:{
        kycType:'2',
        company:undefined,
        companyNumber:undefined,
        realName:undefined,
        phone:undefined,
        idCard:undefined,
        personHeadImg:undefined,
        personBackImg:undefined,
        personPeopleImg:undefined,
        companyImg:undefined
      },
    };
  },
  methods: {
    //获取当前登录账号的认证信息，为认证跳转到实名认证
    userAuthInfo(){
        userAuthenticationInfo().then(res=>{
            if(res.data.code == 200){
                let data = res.data.data;
                if(!!data){
                  this.form = data;
                }else{
                  this.$router.push('/users/authentication')
                }
            }
        });
    },
  },
  mounted() {

  },
  created() {
      this.userAuthInfo();
  }
};
</script>
<style scoped lang="less">
.content{
  padding: 50px;
}

.avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:138px;
    height: 138px;
  }
.avatar-uploader:hover {
  border-color: #409EFF;
}
.svg-avatar-uploader-icon{
  font-size: 28px;
  width: 138px;
  height: 138px;
  line-height: 138px;
  text-align: center;
}
.avatar {
  width: 138px;
  height: 138px;
  display: block;
}
</style>


